import { SET_PAGE } from "../types";

type PageState = {
  path: string;
  url: string;
  params: string | null;
};

const initialState: PageState = {
  path: "",
  url: "",
  params: null,
};

function pageReducer(state = initialState, action): PageState {
  switch (action.type) {
    case SET_PAGE:
      return {
        ...state,
        path: action.payload.path,
        url: action.payload.url,
        params: action.payload.params,
      };
    default:
      return state;
  }
}

export default pageReducer;
